import dynamic from 'next/dynamic';

export const FormCBookingDynamic = dynamic(() => import('./FormCBooking'), {
	ssr: false,
});

export const FormCBookingNewDynamic = dynamic(
	() => import('./FormCBookingNew'),
	{
		ssr: false,
	},
);

export const FormCChoiceDynamic = dynamic(() => import('./FormCChoiceNew'), {
	ssr: false,
});

export const FormCQuestionDynamic = dynamic(() => import('./FormCQuestion'), {
	ssr: false,
});

export default {
	FormCBookingDynamic,
	FormCChoiceDynamic,
	FormCQuestionDynamic,
};
